module.exports = __webpack_public_path__ + "static/contents3-b85a2632cdd5c45f11969a5e5d0d649e.jpg";